import { Button, Stack, Text } from '@chakra-ui/react';
import Script from 'next/script';
import { VelloEmbedProps } from '../types';
import { useTranslation } from '../lib/hooks.context';
import { useCookieConsent } from '../lib/hooks';

const VelloEmbed = ({ id }: VelloEmbedProps) => {
  const { consent, renewConsent } = useCookieConsent(true);
  const t = useTranslation();

  return (
    <div>
      {consent?.preferences ? (
        <div>
          <Script
            id="vello-script"
            dangerouslySetInnerHTML={{
              __html: `(function(d,s,i,c,j,a){a=d.getElementsByTagName(s)[0];if(d.getElementById(i))return;j=d.createElement(s);j.id=i;j.async=1;j.setAttribute("data-c",c);j.src="https://static.vello.fi/js/wizard/vwiz.js";a.parentNode.insertBefore(j,a);}(document,"script","vello-wizard-sdk","${id}"));`,
            }}
          />
          <div id="vello-wizard" />
        </div>
      ) : (
        <Stack
          shouldWrapChildren
          mt={8}
          mx="auto"
          py={8}
          px={[8, 8, 8, '8.33333333%']}
          textAlign="center"
          borderRadius="lg"
          borderWidth="1px"
          borderColor="gray3"
          maxW="container.md"
        >
          <Text mb="4">{t('bot_no_cookies')}</Text>

          <Button
            size="sm"
            colorScheme="primary"
            variant="solidGreen"
            onClick={renewConsent}
          >
            {t('change_cookie_preferences')}
          </Button>
        </Stack>
      )}
    </div>
  );
};
export default VelloEmbed;
